export const AppContainerId = 'veilederVgsUtenUngdomsrett';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksC = 'boks-c';
export const BoksD = 'boks-d';
export const BoksE = 'boks-e';
export const BoksF = 'boks-f';
export const ResultatG = 'resultat-g';
export const ResultatGu = 'resultat-gu';
export const ResultatGx = 'resultat-gx';
export const BoksH = 'boks-h';
export const ResultatF = 'resultat-f';
